import { SignHelper } from 'src/app/helpers/sign-helper';
import { BoardTypeChoices } from 'src/app/model/product/board/board-part';
import IPBoard from 'src/app/model/product/ip-board/ip-board';
import IPBoardPart from 'src/app/model/product/ip-board/ip-board-part';
import { IP_BOARD_PART_TYPE_CHOICES } from 'src/app/model/product/ip-board/ip-board-part-type';
import { IPBoardPlacementTypeChoices } from 'src/app/model/product/ip-board/ip-board-placement-type';

export class ClientIPBoardAndPlacementHelper {
  public static readonly ASSETS_URL_PREFIX = '/assets/client-ip-board/';
  private static NO_OP = (ipBoard: IPBoard, iPBoardPart: IPBoardPart) => {};

  // ----- Board options -----
  public static readonly IP_BOARD_BOARD_OPTIONS = {
    SINGLE_SIDED: {
      label: 'Enkel bord',
      previewUrl: `${ClientIPBoardAndPlacementHelper.ASSETS_URL_PREFIX}enkel-bord.png`,
      onSelect: (ipBoardPart: IPBoardPart) => {
        ipBoardPart.boardType = BoardTypeChoices.SINGLE_SIDED;
        ipBoardPart.placementType = null;
      },
      verify: ClientIPBoardAndPlacementHelper.NO_OP,
    },
    DOUBLE_SIDED: {
      label: 'Dubbelzijdig bord',
      previewUrl: `${ClientIPBoardAndPlacementHelper.ASSETS_URL_PREFIX}dubbelzijdig-bord.png`,
      onSelect: (ipBoardPart: IPBoardPart) => {
        ipBoardPart.boardType = BoardTypeChoices.DOUBLE_SIDED;
        ipBoardPart.placementType = null;
      },
      verify: ClientIPBoardAndPlacementHelper.NO_OP,
    },
    V: {
      label: 'V-bord',
      previewUrl: `${ClientIPBoardAndPlacementHelper.ASSETS_URL_PREFIX}v-bord.png`,
      onSelect: (ipBoardPart: IPBoardPart) => {
        ipBoardPart.boardType = BoardTypeChoices.V;
        ipBoardPart.placementType = null;
      },
      verify: ClientIPBoardAndPlacementHelper.NO_OP,
    },
  };

  public static readonly IP_BOARD_BOARD_OPTIONS_ARRAY = Object.values(
    ClientIPBoardAndPlacementHelper.IP_BOARD_BOARD_OPTIONS
  );

  public static readonly IP_BOARD_LEFT_RIGHT_BOARD_OPTIONS_ARRAY = [
    ClientIPBoardAndPlacementHelper.IP_BOARD_BOARD_OPTIONS.DOUBLE_SIDED,
    ClientIPBoardAndPlacementHelper.IP_BOARD_BOARD_OPTIONS.V,
  ];

  public static readonly ADHESIVE_BOARD_BOARD_OPTIONS = {
    V: {
      label: 'V-bord',
      previewUrl: `${ClientIPBoardAndPlacementHelper.ASSETS_URL_PREFIX}v-bord.png`,
      onSelect: (ipBoardPart: IPBoardPart) => {
        ipBoardPart.boardType = BoardTypeChoices.V;
        ipBoardPart.placementType = null;
      },
      verify: ClientIPBoardAndPlacementHelper.NO_OP,
    },
  };

  public static readonly ADHESIVE_BOARD_BOARD_OPTIONS_ARRAY = Object.values(
    ClientIPBoardAndPlacementHelper.ADHESIVE_BOARD_BOARD_OPTIONS
  );

  // ----- Placement type options -----

  public static readonly SINGLE_SIDED_PLACEMENT_OPTIONS = {
    FACADE: {
      label: 'Gevel',
      previewUrl: `${ClientIPBoardAndPlacementHelper.ASSETS_URL_PREFIX}enkelzijdig-gevel.png`,
      onSelect: (ipBoardPart: IPBoardPart) => {
        ipBoardPart.placementType =
          IPBoardPlacementTypeChoices.ATTACHED_TO_FACADE;
      },
      verify: ClientIPBoardAndPlacementHelper.NO_OP,
    },
    BALCONY: {
      label: 'Balkon',
      previewUrl: `${ClientIPBoardAndPlacementHelper.ASSETS_URL_PREFIX}enkelzijdig-balkon.png`,
      onSelect: (ipBoardPart: IPBoardPart) => {
        ipBoardPart.placementType = IPBoardPlacementTypeChoices.BALCONY;
      },
      verify: ClientIPBoardAndPlacementHelper.NO_OP,
    },
    STRETCHED: {
      label: 'Opgespannen',
      previewUrl: `${ClientIPBoardAndPlacementHelper.ASSETS_URL_PREFIX}enkelzijdig-opgespannen.png`,
      onSelect: (ipBoardPart: IPBoardPart) => {
        ipBoardPart.placementType = IPBoardPlacementTypeChoices.STRETCHED;
      },
      verify: ClientIPBoardAndPlacementHelper.NO_OP,
    },
    ON_POSTS: {
      label: 'Op palen',
      previewUrl: `${ClientIPBoardAndPlacementHelper.ASSETS_URL_PREFIX}enkelzijdig-op-palen.png`,
      onSelect: (ipBoardPart: IPBoardPart) => {
        ipBoardPart.placementType = IPBoardPlacementTypeChoices.ON_POSTS;
      },
      verify: ClientIPBoardAndPlacementHelper.NO_OP,
    },
    ON_STONES: {
      label: 'Stenen',
      previewUrl: `${ClientIPBoardAndPlacementHelper.ASSETS_URL_PREFIX}enkelzijdig-op-steen.png`,
      onSelect: (ipBoardPart: IPBoardPart) => {
        ipBoardPart.placementType = IPBoardPlacementTypeChoices.ON_STONES;
      },
      verify: ClientIPBoardAndPlacementHelper.NO_OP,
    },
  };

  public static readonly SINGLE_SIDED_PLACEMENT_OPTIONS_ARRAY = Object.values(
    ClientIPBoardAndPlacementHelper.SINGLE_SIDED_PLACEMENT_OPTIONS
  );

  public static readonly DOUBLE_SIDED_PLACEMENT_OPTIONS = {
    ON_POSTS: {
      label: 'Op palen',
      previewUrl: `${ClientIPBoardAndPlacementHelper.ASSETS_URL_PREFIX}dubbelzijdig-op-palen.png`,
      onSelect: (ipBoardPart: IPBoardPart) => {
        ipBoardPart.placementType = IPBoardPlacementTypeChoices.ON_POSTS;
      },
      verify: ClientIPBoardAndPlacementHelper.NO_OP,
    },
    ON_STONES: {
      label: 'Stenen',
      previewUrl: `${ClientIPBoardAndPlacementHelper.ASSETS_URL_PREFIX}dubbelzijdig-op-steen.png`,
      onSelect: (ipBoardPart: IPBoardPart) => {
        ipBoardPart.placementType = IPBoardPlacementTypeChoices.ON_STONES;
      },
      verify: ClientIPBoardAndPlacementHelper.NO_OP,
    },
  };

  public static readonly DOUBLE_SIDED_PLACEMENT_OPTIONS_ARRAY = Object.values(
    ClientIPBoardAndPlacementHelper.DOUBLE_SIDED_PLACEMENT_OPTIONS
  );

  public static readonly V_IP_BOARD_PLACEMENT_OPTIONS = {
    FACADE: {
      label: 'Gevel',
      previewUrl: `${ClientIPBoardAndPlacementHelper.ASSETS_URL_PREFIX}v-bord-gevel.png`,
      onSelect: (ipBoardPart: IPBoardPart) => {
        ipBoardPart.placementType =
          IPBoardPlacementTypeChoices.ATTACHED_TO_FACADE;
      },
      verify: ClientIPBoardAndPlacementHelper.NO_OP,
    },
    BALCONY: {
      label: 'Balkon',
      previewUrl: `${ClientIPBoardAndPlacementHelper.ASSETS_URL_PREFIX}v-bord-balkon.png`,
      onSelect: (ipBoardPart: IPBoardPart) => {
        ipBoardPart.placementType = IPBoardPlacementTypeChoices.BALCONY;
      },
      verify: ClientIPBoardAndPlacementHelper.NO_OP,
    },
    STRETCHED: {
      label: 'Opgespannen',
      previewUrl: `${ClientIPBoardAndPlacementHelper.ASSETS_URL_PREFIX}v-bord-opgespannen.png`,
      onSelect: (ipBoardPart: IPBoardPart) => {
        ipBoardPart.placementType = IPBoardPlacementTypeChoices.STRETCHED;
      },
      verify: ClientIPBoardAndPlacementHelper.NO_OP,
    },
    ON_POSTS: {
      label: 'Op palen',
      previewUrl: `${ClientIPBoardAndPlacementHelper.ASSETS_URL_PREFIX}v-bord-op-palen.png`,
      onSelect: (ipBoardPart: IPBoardPart) => {
        ipBoardPart.placementType = IPBoardPlacementTypeChoices.ON_POSTS;
      },
      verify: ClientIPBoardAndPlacementHelper.NO_OP,
    },
    ON_STONES: {
      label: 'Stenen',
      previewUrl: `${ClientIPBoardAndPlacementHelper.ASSETS_URL_PREFIX}v-bord-op-steen.png`,
      onSelect: (ipBoardPart: IPBoardPart) => {
        ipBoardPart.placementType = IPBoardPlacementTypeChoices.ON_STONES;
      },
      verify: ClientIPBoardAndPlacementHelper.NO_OP,
    },
  };

  public static readonly V_IP_BOARD_PLACEMENT_OPTIONS_ARRAY = Object.values(
    ClientIPBoardAndPlacementHelper.V_IP_BOARD_PLACEMENT_OPTIONS
  );

  public static readonly V_ADHESIVE_PLACEMENT_OPTIONS = {
    WINDOW: {
      label: 'Aan het raam',
      previewUrl: `${ClientIPBoardAndPlacementHelper.ASSETS_URL_PREFIX}kleefbord-raam.png`,
      onSelect: (ipBoardPart: IPBoardPart) => {
        ipBoardPart.placementType = IPBoardPlacementTypeChoices.WINDOW;
      },
      verify: ClientIPBoardAndPlacementHelper.NO_OP,
    },
    BALCONY: {
      label: 'Aan balkon',
      previewUrl: `${ClientIPBoardAndPlacementHelper.ASSETS_URL_PREFIX}kleefbord-balkon.png`,
      onSelect: (ipBoardPart: IPBoardPart) => {
        ipBoardPart.placementType = IPBoardPlacementTypeChoices.BALCONY;
      },
      verify: ClientIPBoardAndPlacementHelper.NO_OP,
    },
  };

  public static readonly V_ADHESIVE_PLACEMENT_OPTIONS_ARRAY = Object.values(
    ClientIPBoardAndPlacementHelper.V_ADHESIVE_PLACEMENT_OPTIONS
  );

  static getInitialSelectedBoardOption(
    ipBoardPart: IPBoardPart
  ): SignBoardOrPlacementOption {
    return ClientIPBoardAndPlacementHelper.isAdhesiveBoard(ipBoardPart)
      ? ClientIPBoardAndPlacementHelper.ADHESIVE_BOARD_BOARD_OPTIONS.V
      : ClientIPBoardAndPlacementHelper.getInitialSelectedIPBoardOption(
          ipBoardPart
        );
  }

  static getInitialSelectedPlacementOption(
    ipBoardPart: IPBoardPart
  ): SignBoardOrPlacementOption {
    return this.isAdhesiveBoard(ipBoardPart)
      ? this.doGetInitialSelectedAdhesiveBoardPlacementOption(ipBoardPart)
      : this.getInitialSelectedIPBoardPlacementOption(ipBoardPart);
  }

  static isAdhesiveBoard(ipBoardPart: IPBoardPart): boolean {
    return (
      (ipBoardPart.sign == null &&
        ipBoardPart.otherIPBoardPartType != null &&
        ipBoardPart.otherIPBoardPartType.ordinal ===
          IP_BOARD_PART_TYPE_CHOICES.ADHESIVE_BOARD.ordinal) ||
      (ipBoardPart.sign != null &&
        SignHelper.stockSignIsAdhesive(ipBoardPart.sign))
    );
  }

  private static getInitialSelectedIPBoardOption(
    ipBoardPart: IPBoardPart
  ): SignBoardOrPlacementOption {
    if (ipBoardPart.boardType == null) {
      return null;
    }
    switch (ipBoardPart.boardType.ordinal) {
      case BoardTypeChoices.SINGLE_SIDED.ordinal:
        return ClientIPBoardAndPlacementHelper.IP_BOARD_BOARD_OPTIONS
          .SINGLE_SIDED;
      case BoardTypeChoices.DOUBLE_SIDED.ordinal:
        return ClientIPBoardAndPlacementHelper.IP_BOARD_BOARD_OPTIONS
          .DOUBLE_SIDED;
      case BoardTypeChoices.V.ordinal:
        return ClientIPBoardAndPlacementHelper.IP_BOARD_BOARD_OPTIONS.V;
      case BoardTypeChoices.DIVERGENT.ordinal:
        return null;
      default:
        throw new Error(
          `Board type ordinal not recognized: ${ipBoardPart.boardType.ordinal}`
        );
    }
  }

  static getInitialSelectedAdhesiveBoardPlacementOption(
    ipBoardPart: IPBoardPart
  ): SignBoardOrPlacementOption {
    return ipBoardPart.boardType == null || ipBoardPart.placementType == null
      ? null
      : this.doGetInitialSelectedAdhesiveBoardPlacementOption(ipBoardPart);
  }

  static getInitialSelectedIPBoardPlacementOption(
    ipBoardPart: IPBoardPart
  ): SignBoardOrPlacementOption {
    if (ipBoardPart.boardType == null || ipBoardPart.placementType == null) {
      return null;
    }
    switch (ipBoardPart.boardType.ordinal) {
      case BoardTypeChoices.SINGLE_SIDED.ordinal:
        return ClientIPBoardAndPlacementHelper.getInitialSelectedSingleSidedPlacementOption(
          ipBoardPart
        );
      case BoardTypeChoices.DOUBLE_SIDED.ordinal:
        return ClientIPBoardAndPlacementHelper.getInitialSelectedDoubleSidedPlacementOption(
          ipBoardPart
        );
      case BoardTypeChoices.V.ordinal:
        return ClientIPBoardAndPlacementHelper.getInitialSelectedVPlacementOption(
          ipBoardPart
        );
      case BoardTypeChoices.DIVERGENT.ordinal:
        return null;
      default:
        throw new Error(
          `Board type ordinal not recognized: ${ipBoardPart.boardType.ordinal}`
        );
    }
  }

  private static getInitialSelectedSingleSidedPlacementOption(
    ipBoardPart: IPBoardPart
  ): SignBoardOrPlacementOption {
    switch (ipBoardPart.placementType.ordinal) {
      case IPBoardPlacementTypeChoices.ATTACHED_TO_FACADE.ordinal:
        return ClientIPBoardAndPlacementHelper.SINGLE_SIDED_PLACEMENT_OPTIONS
          .FACADE;
      case IPBoardPlacementTypeChoices.BALCONY.ordinal:
        return ClientIPBoardAndPlacementHelper.SINGLE_SIDED_PLACEMENT_OPTIONS
          .BALCONY;
      case IPBoardPlacementTypeChoices.STRETCHED.ordinal:
        return ClientIPBoardAndPlacementHelper.SINGLE_SIDED_PLACEMENT_OPTIONS
          .STRETCHED;
      case IPBoardPlacementTypeChoices.ON_POSTS.ordinal:
        return ClientIPBoardAndPlacementHelper.SINGLE_SIDED_PLACEMENT_OPTIONS
          .ON_POSTS;
      case IPBoardPlacementTypeChoices.ON_STONES.ordinal:
        return ClientIPBoardAndPlacementHelper.SINGLE_SIDED_PLACEMENT_OPTIONS
          .ON_STONES;
      default:
        return null;
    }
  }

  private static getInitialSelectedDoubleSidedPlacementOption(
    ipBoardPart: IPBoardPart
  ): SignBoardOrPlacementOption {
    switch (ipBoardPart.placementType.ordinal) {
      case IPBoardPlacementTypeChoices.ON_POSTS.ordinal:
        return ClientIPBoardAndPlacementHelper.DOUBLE_SIDED_PLACEMENT_OPTIONS
          .ON_POSTS;
      case IPBoardPlacementTypeChoices.ON_STONES.ordinal:
        return ClientIPBoardAndPlacementHelper.DOUBLE_SIDED_PLACEMENT_OPTIONS
          .ON_STONES;
      default:
        return null;
    }
  }

  private static getInitialSelectedVPlacementOption(
    ipBoardPart: IPBoardPart
  ): SignBoardOrPlacementOption {
    switch (ipBoardPart.placementType.ordinal) {
      case IPBoardPlacementTypeChoices.ATTACHED_TO_FACADE.ordinal:
        return ClientIPBoardAndPlacementHelper.V_IP_BOARD_PLACEMENT_OPTIONS
          .FACADE;
      case IPBoardPlacementTypeChoices.BALCONY.ordinal:
        return ClientIPBoardAndPlacementHelper.V_IP_BOARD_PLACEMENT_OPTIONS
          .BALCONY;
      case IPBoardPlacementTypeChoices.STRETCHED.ordinal:
        return ClientIPBoardAndPlacementHelper.V_IP_BOARD_PLACEMENT_OPTIONS
          .STRETCHED;
      case IPBoardPlacementTypeChoices.ON_POSTS.ordinal:
        return ClientIPBoardAndPlacementHelper.V_IP_BOARD_PLACEMENT_OPTIONS
          .ON_POSTS;
      case IPBoardPlacementTypeChoices.ON_STONES.ordinal:
        return ClientIPBoardAndPlacementHelper.V_IP_BOARD_PLACEMENT_OPTIONS
          .ON_STONES;
      default:
        return null;
    }
  }

  private static doGetInitialSelectedAdhesiveBoardPlacementOption(
    ipBoardPart: IPBoardPart
  ): SignBoardOrPlacementOption {
    switch (ipBoardPart.placementType.ordinal) {
      case IPBoardPlacementTypeChoices.WINDOW.ordinal:
        return ClientIPBoardAndPlacementHelper.V_ADHESIVE_PLACEMENT_OPTIONS
          .WINDOW;
      case IPBoardPlacementTypeChoices.BALCONY.ordinal:
        return ClientIPBoardAndPlacementHelper.V_ADHESIVE_PLACEMENT_OPTIONS
          .BALCONY;
      default:
        return null;
    }
  }
}

export interface SignBoardOrPlacementOption {
  label: string;
  previewUrl: string;
  onSelect: (ipBoardPart: IPBoardPart) => void;
  verify: (ipBoard: IPBoard, ipBoardPart: IPBoardPart) => void;
}
